import type { CollectionItem } from '@/data/schema/collection-item'

export default function useCollections() {
	/**
	 * Get unique journey numbers from items for dropdown
	 */
	function getJourneyNumberOptions(items: CollectionItem[]) {
		const journeyNumbers = Array.from(
			new Set(
				items
					.filter((obj) => obj.journey_number)
					.map((obj) => obj.journey_number)
					.sort((a, b) => parseInt(a ?? '') - parseInt(b ?? ''))
			)
		)

		return journeyNumbers.map((value) => ({ value }))
	}

	return {
		getJourneyNumberOptions
	}
}
